// Market
export const AVG_APY_DURATION_LABEL = '6H'
// Vault
export const APY_DURATION_LABEL = 'Instant'
